export default __webpack_public_path__ + "static/media/Amy_Millman_AHV_In_Moms_We_Trust.9ae25427.jpg";